// test1939
(1939 && 0);
